/**
 * Analytics API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VisitorCountingMode = 'in' | 'out' | 'average';

export const VisitorCountingMode = {
    In: 'in' as VisitorCountingMode,
    Out: 'out' as VisitorCountingMode,
    Average: 'average' as VisitorCountingMode
};

